import http from '../auth/httpService';

const apiEndpoint = '/reports';

function reportUrl(state) {
  return `${apiEndpoint}/${state.projectSlug}`;
}

export function generateMontlyReport(state) {
  if (state.projectSlug) {
    const body = { ...state };
    delete body.projectSlug;
    delete body.projectName;
    return http.post(reportUrl(state), body);
  }
}

export function getReportsByStartAndEndDateByProject(
  startDate,
  endDate,
  projectId
) {
  return http.get(`${apiEndpoint}/${startDate}/${endDate}/${projectId}`);
}

export function getReportType(projectSlug, year, month) {
  return http.get(`${apiEndpoint}/type/${projectSlug}/${year}/${month}`);
}
